import axios from 'axios'
import { ConsignmentItemResponse, CreateOrUpdateConsignmentItemRequest } from '../../../../api/models'
import { ConsignmentItemResponseV3 } from '../../../../api/models/consignment-item-response-v3'
import { ConsignmentItemDetailsResponseV3 } from '../../../../api/models/consignment-item-details-response-v3'
import { ConsignmentItemCountResponse } from '../../../../api/models/consignment-item-count-response'
import { BulkUploadResponseV3 } from '../../../../api/models/bulk-upload-response-v3'
import { BulkDeleteConsignmentItemsRequestV3 } from '../../../../api/models/bulk-delete-consignment-items-request-v3'
import { PatchConsignmentItemRequest } from '../../../../api/models/patch-consignment-item-request'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchConsignmentItemsV3(
  params: { consignmentId: number; houseConsignmentId?: number },
  opts?: { signal?: AbortSignal },
) {
  const { data } = await axios.get<ConsignmentItemResponseV3[]>(`${baseUrl}/v3/consignment-item`, {
    signal: opts?.signal,
    params: {
      consignmentId: params.consignmentId,
      ...(params.houseConsignmentId ? { houseConsignmentId: params.houseConsignmentId } : {}),
    },
  })

  return data
}

export async function fetchConsignmentItemV3(id: number, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item/${id}`, {
    signal: opts?.signal,
  })

  return data
}

export async function createConsignmentItemsV2(items: CreateOrUpdateConsignmentItemRequest[]) {
  const { data } = await axios.post<ConsignmentItemResponse[]>(`${baseUrl}/v2/consignment-item`, items)

  return data
}

export async function updateConsignmentItemsV2(items: CreateOrUpdateConsignmentItemRequest[]) {
  const { data } = await axios.put<ConsignmentItemResponse[]>(`${baseUrl}/v2/consignment-item`, items)

  return data
}

export async function createConsignmentItemV3(item: CreateOrUpdateConsignmentItemRequest) {
  const { data } = await axios.post<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item`, item)

  return data
}

export async function duplicateConsignmentItemV3(id: number) {
  const { data } = await axios.post<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item/${id}/duplicate`)

  return data
}

export async function createConsignmentItemDraftV3(item: CreateOrUpdateConsignmentItemRequest) {
  const { data } = await axios.post<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item/draft`, item)

  return data
}

export async function updateConsignmentItemV3(id: number, item: CreateOrUpdateConsignmentItemRequest) {
  const { data } = await axios.put<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item/${id}`, item)

  return data
}

export async function updateConsignmentItemDraftV3(id: number, item: CreateOrUpdateConsignmentItemRequest) {
  const { data } = await axios.put<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item/${id}/draft`, item)

  return data
}

export async function patchConsignmentItemV3(id: number, request: PatchConsignmentItemRequest) {
  const { data } = await axios.patch<ConsignmentItemDetailsResponseV3>(`${baseUrl}/v3/consignment-item/${id}`, request)

  return data
}

export async function deleteConsignmentItemV2(id: number) {
  const { data } = await axios.delete<void>(`${baseUrl}/v2/consignment-item/${id}`)

  return data
}

export async function bulkUploadItemsCsvV3(consignmentId: number, formData: FormData) {
  const { data } = await axios.post<BulkUploadResponseV3>(
    `${baseUrl}/v3/consignment-item/bulk-upload/consignment/${consignmentId}`,
    formData,
    {
      timeout: 60_000,
    },
  )

  return data
}

export async function bulkDeleteConsignmentItemsV3(request: BulkDeleteConsignmentItemsRequestV3) {
  await axios.delete<void>(`${baseUrl}/v3/consignment-item/bulk-delete`, {
    data: request,
  })
}

export async function countConsignmentItems(
  params: { consignmentId: number; houseConsignmentId?: number },
  opts?: { signal?: AbortSignal },
) {
  const { data } = await axios.get<ConsignmentItemCountResponse>(`${baseUrl}/v3/consignment-item/count`, {
    params: {
      consignmentId: params.consignmentId,
      ...(params.houseConsignmentId ? { houseConsignmentId: params.houseConsignmentId } : {}),
    },
    signal: opts?.signal,
  })

  return data
}
